var _defs, _g, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKonbini(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logosandtypes_com",
    "data-name": "logosandtypes com",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#1e32c8;}.cls-3{fill:#ffc800;}.cls-4{fill:#fa1e14;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer_3-2",
    "data-name": "Layer 3",
    className: "cls-1",
    d: "M0,.2H150v150H0Z",
    transform: "translate(0 -0.2)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.84,26.52A11.68,11.68,0,0,1,28.48,14.87H81.6L16.84,113.55v-87",
    transform: "translate(0 -0.2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M62.79,136.33l42.83-65.14,31.12,48.36a11.82,11.82,0,0,1,.49,11.22,9.8,9.8,0,0,1-8.39,5.43H70.4v.13",
    transform: "translate(0 -0.2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M28.48,136.33a11.68,11.68,0,0,1-11.64-11.64v-13l63-96.79h45.92a9.78,9.78,0,0,1,8,4.87A11.42,11.42,0,0,1,134.27,30L66.11,136.33H28.48",
    transform: "translate(0 -0.2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKonbini);
export default __webpack_public_path__ + "static/media/konbini.29029db6bb4ff9d950c3c2d9df6443a6.svg";
export { ForwardRef as ReactComponent };